import { Div, Ref, Span, Text } from "@tblabs/truffle";


export class TooltipLabel extends Div
{
    private label = new Text("...").Class("tooltip-text")
    private infoLabel = new Span("...").Class("tooltip-text-on-hover")

    constructor(text?: string | Ref<string>, info?: string)
    {
        super();
        this.Class("tooltip")

        if (text)
        {
            this.label.Text(text);
        }

        if (info)
        {
            this.infoLabel.Text(info);
        }

        this.Append(
            this.label,
            this.infoLabel
        )
    }

    public Set(text: string | Ref<string>, info?: string)
    {
        this.label.Text(text);

        if (info)
        {
            this.infoLabel.Text(info);
        }
    }
}
